import React from 'react';

/*
 * Inline SVG icons ported from the design reference (assistant.js).
 * `@ant-design/icons` has no matching "spark" glyph, so the assistant uses
 * these inline SVGs (sized via CSS on the parent). stroke=currentColor lets
 * each icon inherit the surrounding text color.
 */

type IconProps = React.SVGProps<SVGSVGElement>;

const base: IconProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  'aria-hidden': true,
  focusable: false,
};

export const SparkIcon = (p: IconProps) => (
  <svg
    {...base}
    strokeWidth={1.7}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...p}
  >
    <path d="M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z" />
    <path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z" />
  </svg>
);

export const CloseIcon = (p: IconProps) => (
  <svg {...base} strokeWidth={2} {...p}>
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

export const PlusIcon = (p: IconProps) => (
  <svg {...base} strokeWidth={2} {...p}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const HistoryIcon = (p: IconProps) => (
  <svg {...base} strokeWidth={1.8} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 3" />
  </svg>
);

export const BackIcon = (p: IconProps) => (
  <svg {...base} strokeWidth={2} {...p}>
    <path d="M19 12H5M12 19l-7-7 7-7" />
  </svg>
);

export const SendIcon = (p: IconProps) => (
  <svg {...base} strokeWidth={2} {...p}>
    <path d="M12 19V5M5 12l7-7 7 7" />
  </svg>
);

export const CheckIcon = (p: IconProps) => (
  <svg {...base} strokeWidth={2.4} {...p}>
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

export const ArrowIcon = (p: IconProps) => (
  <svg {...base} strokeWidth={2} {...p}>
    <path d="M5 12h14M12 5l7 7-7 7" />
  </svg>
);

export const WarnIcon = (p: IconProps) => (
  <svg {...base} strokeWidth={2} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 8v4M12 16h.01" />
  </svg>
);

export const SearchIcon = (p: IconProps) => (
  <svg {...base} strokeWidth={1.8} {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="m21 21-4.3-4.3" />
  </svg>
);

export const ShieldIcon = (p: IconProps) => (
  <svg {...base} strokeWidth={1.8} {...p}>
    <path d="M12 22s8-3 8-10V5l-8-3-8 3v7c0 7 8 10 8 10z" />
  </svg>
);

export const LifebuoyIcon = (p: IconProps) => (
  <svg {...base} strokeWidth={1.8} {...p}>
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
  </svg>
);

export const ChevronIcon = (p: IconProps) => (
  <svg {...base} strokeWidth={2} {...p}>
    <path d="M6 9l6 6 6-6" />
  </svg>
);
